import { getAbsPath, sanitizeUrlParam, escapeHtml, getNewsUrl } from '../utils.js';

export function renderCategories(cats, dateSuffix = '') {
  const CATEGORY_CONFIG = {
    'sucesos': { name: 'Sucesos', icon: 'fas fa-shield-alt' },
    'nacionales': { name: 'Nacionales', icon: 'fas fa-flag' },
    'deportes': { name: 'Deportes', icon: 'fas fa-football-ball' },
    'economia': { name: 'Economía', icon: 'fas fa-chart-line' },
    'internacionales': { name: 'Internacionales', icon: 'fas fa-globe' }
  };

  return cats.map(cat => {
    const config = CATEGORY_CONFIG[cat.id] || { name: cat.id || 'Noticias', icon: 'fas fa-newspaper' };
    const catName = config.name;
    const catIcon = config.icon;

    return `
      <div class="category-column fade-in" id="${cat.id}">
        <h3 class="category-column__title"><i class="${catIcon}"></i> ${catName}</h3>
        <article class="cat-card" data-news-category="${catName}" data-news-title="${cat.main.title}">
          <div class="cat-card__img-wrap">
            <img src="${getAbsPath(cat.main.image)}" 
                 srcset="${getAbsPath(cat.main.image).replace('.webp', '-600w.webp')} 600w, ${getAbsPath(cat.main.image).replace('.webp', '-1200w.webp')} 1200w"
                 sizes="(max-width: 600px) 100vw, 300px"
                 alt="${cat.main.title}" class="cat-card__img" loading="lazy" width="300" height="140" decoding="async">
          </div>
          <div class="cat-card__body">
            <h4 class="cat-card__title">${cat.main.title}</h4>
            <p class="cat-card__excerpt">${cat.main.excerpt}</p>
            ${cat.main.slug ? `<a href="${getNewsUrl(cat.main.slug, dateSuffix)}" class="cat-card__link">Ver más <i class="fas fa-chevron-right"></i></a>` : ''}
          </div>
        </article>
        ${cat.secondary.map(sec => `
          <article class="cat-card cat-card--compact" data-news-category="${catName}" data-news-title="${sec.title}">
            <div class="cat-card__body">
              <h4 class="cat-card__title">${sec.title}</h4>
              <p class="cat-card__excerpt">${sec.excerpt}</p>
              ${sec.slug ? `<a href="${getNewsUrl(sec.slug, dateSuffix)}" class="cat-card__link-compact">Leer más <i class="fas fa-chevron-right"></i></a>` : ''}
            </div>
          </article>
        `).join('')}
      </div>
    `;
  }).join('');
}

export function renderTechnology(tech, dateSuffix = '') {
  return tech.map(item => `
    <article class="tech-card fade-in" data-news-category="Tecnología" data-news-title="${item.title}">
      <div class="tech-card__img-wrap">
        <img src="${getAbsPath(item.image)}" 
             srcset="${getAbsPath(item.image).replace('.webp', '-600w.webp')} 600w, ${getAbsPath(item.image).replace('.webp', '-1200w.webp')} 1200w"
             sizes="(max-width: 600px) 100vw, 400px"
             alt="${item.title}" class="tech-card__img" loading="lazy" width="400" height="225" decoding="async">
        <span class="tag ${item.tagClass} tech-card__tag">${item.tag}</span>
      </div>
      <div class="tech-card__content">
        <h3 class="tech-card__title">${item.title}</h3>
        <p class="tech-card__excerpt">${item.excerpt}</p>
        ${item.slug ? `<a href="${getNewsUrl(item.slug, dateSuffix)}" class="tech-card__link">Leer noticia completa <i class="fas fa-arrow-right"></i></a>` : ''}
      </div>
    </article>
  `).join('');
}
